import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { Ng1StateProxyProvider } from "@webapp/core/provider-upgrade/providers/ng1-state.proxy";
import { UiModule } from "@webapp/ui/ui.module";
import { RoleServiceProvider } from "./providers/role-service.provider";
import { RoleEditorComponent } from "./role-editor/role-editor.component";

@NgModule({
  declarations: [RoleEditorComponent],
  imports: [UiModule, BrowserModule, FormsModule],
  providers: [Ng1StateProxyProvider, RoleServiceProvider],
})
export class RolesModule {}
